// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__APxA9","switchOff":"Switch_switchOff__cCUxk","switchOn":"Switch_switchOn__Fzf4e","slider":"Switch_slider__BEqKr","round":"Switch_round__OXI0M"};